$docroot = 'https://lenscustomiser.opticalking.co.uk/app';
wbsk_cart = (function () {
  var _this = {
    update: function (cart) {
      if (!cart) {
        fetch('/cart.js', {
            method: 'GET'
          })
          .then((resp) => resp.json()).then(function (data) {
            _this.process(data);
          });
      } else {
        _this.process(cart);
      };
    },
    process: function (cart) {
      var needs_update = false,
        note = JSON.parse(cart.note),
        new_note = [];
      note.forEach(function (v, k) {
        var cart_item = cart.items.filter(function (item) {
          if (item.properties !== null) {
            return item.properties.u_id == v.u_id;
            return item.properties.product_id == v.product_id;

            //return item.properties.frame_product == v.frame_product; 


            //return item.properties.customizations == v.customizations;

            //return item.properties.prescription == v.prescription;
            //return item.properties.customizations == v.customizations;



          }
        });
        if (cart_item.length == 0) {
          needs_update = true;
        } else {
          new_note.push(v)
        };
      });

      var counter = 0;

      for (var i in new_note) {

        for( var j in new_note[i].data.customizations ){
          var name = new_note[i].data.customizations[j].name;
          var selectedname = new_note[i].data.customizations[j].selected_name;
          var variant = new_note[i].data.customizations[j].variant;

          if ((typeof variant === 'undefined' || variant === '' ) && typeof selectedname !== 'undefined') {

            $('.CartItem__Property_new' + counter).append(name + " : " + selectedname + "<br>").show();

          } else if (typeof selectedname === 'undefined' && typeof variant === 'undefined') {

            $('.CartItem__Property_new' + counter).append(name + "<br>").show();

          } else {

            $('.CartItem__Property_new' + counter).append(name + " : " + selectedname + " : " + variant + "<br>").show();

          }
        }

        counter++;

      }
      if (needs_update == true) {
        new_note = JSON.stringify(new_note);
        var data = {
          note: new_note
        };
        data = JSON.stringify(data);
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
        }).then((resp) => resp.json()).then(function (data) {
          note = JSON.parse(cart.note);
        });
      };
    }
  };
  return _this;
})()